import React from 'react'
import './FilterPanel.css'

type Props = {
    children: React.ReactNode
}

/**
 * Filter Panel should always be used inside ContentBody as shown below
 *
 * <ContentBody>
 *   <FilterPanel></Filter Panel>
 *   <Content></Content>
 * </ContentBody>
 *
 * @param props
 * @constructor
 */

function FilterPanel(props: Props) {
  return (
    <div id="filter-panel">
        {props.children}
    </div>
  )
}

export default FilterPanel
